import { Link } from 'react-router-dom';
import styles from './NotFound.module.css';

export default function NotFound() {
  return (
    <div className={styles.container}>
      <pre className={styles.ascii}>
{`
 ██▀███  ▓█████▄▄▄█████▓ ██▀███  ▓█████ 
▓██ ▒ ██▒▓█   ▀▓  ██▒ ▓██▒▓██ ▒███ ▓█   ▀ 
▓██ ░▄█ ▒▒███  ▒███ ▒██  ▓██▒▓██ ░▒█ ▒███ 
▒██▀▀█▄  ▒▓█  ▄▒███ ▒██ ██░▒██▒▒██ ░▒█ ▒▓█  ▄
░██▓ ▒██▒░▒████░█████▒░ ██░ ░██ ░░  ░▒████
░ ▒▓ ░▒▒░░░ ▒░ ░▒░▒ ░  ░    ░    ░░   ░░ ▒░ 
  ░▒ ░ ▒░ ░ ░  ░ ▒ ▒ ░     ░    ░     ░ ░  ▒
  ░░   ░    ░   ░ ░                     ░   
   ░         ░  ░ ░                           
 ██▒   █▓ ██▓  ▄▄▄       ██▓    ▓█████▄  
▓██░   █▒▓██▒▒████▄    ▓██▒    ░▒   ██   
 ▓██  █▒░▒██▒▒██  ▀█▄  ▒██░    ░░   ██   
  ▒██ █░░░██░░██▄▄▄▄██ ▒██░     ░   ██   
   ▒▀█░  ░██░ ▓█   ▓██▒░██████▒░██▄ ▒██▒ 
   ░ ▐░  ░▓   ▒▒   ▓▒█░░ ▒░▓  ░ ▓██▒░██▒ 
   ░ ░░   ▒ ░  ▒   ▒▒ ░░ ░ ▒  ░ ▒▓▒░▒  ▒ 
     ░░   ▒ ░  ░   ▒       ░ ░   ░▒ ░ ▒ ░ 
      ░   ░        ░  ░    ░  ░  ░░   ░ ░ 
     ░     ░                           ░ 
`}
      </pre>
      <div className={styles.info}>
        <p className={styles.code}>ERROR 404</p>
        <p className={styles.message}>ARCHIVE NOT FOUND IN DATABASE</p>
        <p className={styles.hint}>The requested resource does not exist or has been moved.</p>
      </div>
      <Link to="/" className={styles.link}>← RETURN TO ENTRY</Link>
    </div>
  );
}
